module.exports = "https://static.moomoo.com/components/common-redpacket/images/act-end-nn.d63d5abd1a.png";